import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CardContentLoader from '@/components/card-content-loader.vue';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import NewUserCouponRewardCard from '@tencent/wphk-components-discount-code/components/new-user-coupon-reward/new-user-coupon-reward-card.vue';
import CouponRewardDialog from './coupon-reward-dialog.vue';
import { useNewUser } from './hooks/use-new-user';
import { isUseTipsMark } from '@tencent/wphk-components-discount-code/business/useTipsMark';
import { useBiReport } from './hooks/use-bi-report';
import { useIsShowScanGift } from '../scan-gift-module/hooks/use-is-show-scan-gift';

// ---- hooks ----

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const {
  isReady,
  /** 券信息 */
  couponInfo,
  /** 上报的扩展字段 */
  biExt,
  /** 是否满足展示迎新组件 */
  isShow,
  /** 点击拉起券详情弹层 */
  handleOpenRedeemCouponDialog,
  /** 点击跳转券列表 */
  handleViewCoupon,
} = useNewUser();
const { biReport } = useBiReport();
const { isShowScanGift } = useIsShowScanGift();

// ---- data ----
const isShowModule = computed(() => isShow.value && !isShowScanGift.value); // 跟扫码券礼包互斥

// ---- 事件 ----
/** 点击使用引导 */
const handleClickTips = () => {
  biReport('howtousebtn_click');
};

/** 点击tips */
const handleGotoTips = () => {
  biReport('howtousebtn_popupbtn_click', '', {
    fusepopup: !isUseTipsMark ? 'use' : 'howtouse',
  });
};


return { __sfc: true,isReady, couponInfo, biExt, isShow, handleOpenRedeemCouponDialog, handleViewCoupon, biReport, isShowScanGift, isShowModule, handleClickTips, handleGotoTips, CardContentLoader, BaseComponent, NewUserCouponRewardCard, CouponRewardDialog }
}

})